import { render } from "./Topic.vue?vue&type=template&id=7fc9801b&scoped=true"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"

import "./Topic.vue?vue&type=style&index=0&id=7fc9801b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7fc9801b"

export default script